export default __webpack_public_path__ + "static/media/startups.05e9854d.svg";